import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import useUserAttributes from "../../hooks/useUserDetails";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Collapsible,
  Layer,
  Heading,
  Text,
  Anchor,
} from "grommet";
import { CircleInformation, User } from "grommet-icons";
import ManageUserProfile from "../ManageUserProfile";
import { BuiltBy } from "./BuiltBy";

function UserPortal({ userPortalOpen, setUserPortalOpen, userPortalRef }) {
  const { user, signOut } = useAuthenticator();
  const { userAttributes, refreshUserAttributes } = useUserAttributes(user);

  const [stage, setStage] = useState(0);
  const [show, setShow] = React.useState(false);
  const onShow = () => setShow(true);

  const onClose = () => setShow(false);

  useEffect(() => {
    setStage(0);
  }, [userPortalOpen]);

  return (
    <Box align="start" gap="small" ref={userPortalRef}>
      <Button
        onClick={() => {
          setUserPortalOpen(!userPortalOpen);
        }}
        icon={<User color="black" />}
      />

      <Collapsible direction="horizontal" open={userPortalOpen}>
        <Box
          background="light-1"
          round="24px"
          pad="5px"
          style={{
            position: "absolute",
            top: "5em",
            right: 20,
            zIndex: 1,
            minWidth: "150px",
          }}
        >
          <Authenticator
            initialState="signUp"
            loginMechanisms={["email"]}
            signUpAttributes={[
              "birthdate",
              "given_name",
              "gender",
              "preferred_username",
            ]}
          >
            {stage === 0 && (
              <Box gap="medium">
                <Box direction="row">
                  <Button label="My Profile" onClick={() => setStage(1)} />
                  <Button
                    onClick={() => setShow(true)}
                    className="informationLink"
                    plain
                    label={<CircleInformation className="informationLink" />}
                  />
                </Box>

                {show && <BuiltBy close={onClose} />}

                <Button label="Sign Out" onClick={() => signOut()} />
              </Box>
            )}
            {stage === 1 && (
              <ManageUserProfile
                userAttributes={userAttributes}
                refreshUserAttributes={refreshUserAttributes}
                goBack={() => setStage(0)}
              />
            )}
          </Authenticator>
        </Box>
      </Collapsible>
    </Box>
  );
}

export default UserPortal;
